/**
 * Global Constants and Configuration
 */

// Card dimensions (standard aspect ratio)
export const CARD_WIDTH = 512;
export const CARD_HEIGHT = 768;
export const CARD_ASPECT_RATIO = CARD_WIDTH / CARD_HEIGHT;

// 3D Scene settings
export const CAMERA_FOV = 45;
export const CAMERA_NEAR = 0.1;
export const CAMERA_FAR = 1000;
export const CAMERA_INITIAL_Z = 2.2;

// Renderer settings
export const ENABLE_ANTIALIASING = true;
export const ENABLE_SHADOWS = true; // Enable shadows for realistic card depth

// Performance settings
export const TARGET_FPS = 60;
export const TEXTURE_MAX_SIZE = 2048;

// Export settings
export const EXPORT_SCALE_FACTOR = 4; // 4x resolution for export
export const EXPORT_FORMAT = 'image/png';

// Animation settings
export const ENABLE_DAMPING = true;
export const DAMPING_FACTOR = 0.05;

// File upload limits
export const MAX_FILE_SIZE_MB = 5;
export const ALLOWED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/jpg'];

// Template paths
export const TEMPLATE_BASE_PATH = '/assets/templates/';

// Default card state
export const DEFAULT_CARD_STATE = {
  templateId: 'slay-the-spire',
  properties: {
    // Front side properties (normal card)
    energyCost: 2,
    cardName: 'Relentless Strike',
    cardText: 'Deal 7 damage twice. Lose 2 HP.',
    // Back side properties (upgraded version - automatically gets + suffix and green color)
    energyCostBack: 2,
    cardNameBack: 'Relentless Strike',  // Note: + will be added automatically
    cardTextBack: 'Deal 10 damage twice. Lose 2 HP.',
    // Shared properties
    cardType: 'Attack',
    rarity: 'Uncommon',
    upgraded: false
  },
  artwork: {
    front: null,
    back: null
  },
  currentSide: 'front'
};

// Template system constants
export const DEFAULT_GAME_ID = 'slay-the-spire';
export const SUPPORTED_GAMES = ['slay-the-spire'];

// Text rendering constants
export const TEXT_SHADOW_DEFAULT = {
  color: '#000000',
  blur: 4,
  offsetX: 2,
  offsetY: 2
};

// Canvas texture settings
export const CANVAS_TEXTURE_WIDTH = 512;
export const CANVAS_TEXTURE_HEIGHT = 768;

// UV mapping offsets for template positioning (developer setting)
// Adjust these values to center your template on the card
export const UV_OFFSET_X = 0.027; // Horizontal offset (positive = right, negative = left)
export const UV_OFFSET_Y = -0.009; // Vertical offset (positive = up, negative = down)

console.log('Constants loaded');
